// extracted by mini-css-extract-plugin
export default {"DocumentPreviewer":"DocumentPreviewer_DocumentPreviewer__4ZCkr"};